<template>
  <tr :class="{ upload: upload }" @click="onPdfModal" :key="item.id">
    <td>
      <div v-if="edit" class="height width">
        <BaseInput
          :placeholder="
          localStorage.translations.pages.sales_project['schemes_documents-tables']['nazvanie']
        "
          height="48px"
          v-model="data.name"
          :rules="['required', 'max100']"
        />
      </div>
      <div class="name" v-else>
        <ProjectSchemesAndDocumentsPdfModal :url="url">
          <template slot="text">
            <div class="name_top">
              <p class="f14">
                {{ item.name }}
              </p>
              <span class="ml-1">.{{ fileExtension ? fileExtension : item.extension }}</span>
            </div>
          </template>
        </ProjectSchemesAndDocumentsPdfModal>
        <span class="name_size f14">{{ fileSize ? fileSize : item.size }}</span>
      </div>
      <BaseTableUploadProgress
        class="mt-4"
        v-if="tableMin && upload"
        :status="item.status"
        :uploadProgress="uploadSchemesProgress"
      />
    </td>
    <td v-if="!tableMin && upload" :colspan="5">
      <BaseTableUploadProgress :status="item.status" :uploadProgress="uploadSchemesProgress" />
    </td>
    <template v-if="!upload">
      <td>
        <BaseInput
          type="autocomplete"
          :disabled="!schemeTypeList.length"
          prepend-inner-icon="search"
          height="48px"
          v-model="data.scheme_type_id"
          :items="schemeTypeList"
          item-value="id"
          item-text="name"
          :tooltip="
            localStorage.translations.pages.sales_project['schemes_documents-tooltips'][
              'dobavte-tip-chertezha'
            ]
          "
          :tooltip-disabled="!edit || schemeTypeList.length ? true : false"
          :view="!edit"
          :view-value="
            item.type
              ? item.type.name
              : localStorage.translations.pages.sales_project['schemes_documents-tables'][
                  'ne-vybrano'
                ]
          "
        >
          <WorkDocsSchemeTypeModal v-if="edit == true" :create="true" :minimalize="true" />
        </BaseInput>
      </td>
      <td class="f14">
        {{ $formatDate(item.created_at) }}
      </td>
      <td>
        <BaseInput
          type="autocomplete"
          :disabled="!schemeClassList.length"
          prepend-inner-icon="search"
          height="48px"
          v-model="data.scheme_class_id"
          :items="schemeClassList"
          item-value="id"
          item-text="name"
          :tooltip="
            localStorage.translations.pages.sales_project['schemes_documents-tooltips'][
              'dobavte-soderzhanie-chertezha'
            ]
          "
          :tooltip-disabled="!edit || schemeClassList.length ? true : false"
          :view="!edit"
          :view-value="
            item.scheme_class
              ? item.scheme_class.name
              : localStorage.translations.pages.sales_project['schemes_documents-tables'][
                  'ne-vybrano'
                ]
          "
        >
          <WorkDocsSchemeClassModal v-if="edit == true" :create="true" :minimalize="true" />
        </BaseInput>
      </td>
      <td>
        <BaseInput
          type="autocomplete"
          :disabled="!workAreaList.length"
          height="48px"
          v-model="data.work_area_id"
          prepend-inner-icon="search"
          :items="workAreaList"
          item-value="id"
          item-text="name"
          :tooltip="
            localStorage.translations.pages.sales_project['schemes_documents-tooltips'][
              'dobavte-zonu-raboty'
            ]
          "
          :tooltip-disabled="!edit || workAreaList.length ? true : false"
          :view="!edit"
          :view-value="
            item.work_area
              ? item.work_area.name
              : localStorage.translations.pages.sales_project['schemes_documents-tables'][
                  'ne-vybrano'
                ]
          "
        >
          <WorkDocsWorkAreaModal v-if="edit == true" :create="true" :minimalize="true" />
        </BaseInput>
      </td>
      <td>
        <div class="buttons">
          <ProjectSchemesAndDocumentsPdfModal icon-show :url="url" />
          <DeleteModal
            v-if="editShowPage && !edit"
            :item="item"
            type="workDocsProjectSchemes"
            :text="
              localStorage.translations.pages.sales_project['schemes_documents-dialog-delete'][
                'text_scheme'
              ] +
              ' ' +
              item.name
            "
          />
        </div>
      </td>
    </template>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'

import DeleteModal from 'components/DeleteModal'
import WorkDocsSchemeTypeModal from 'components/setting/workDocsSchemeType/WorkDocsSchemeTypeModal'
import WorkDocsSchemeClassModal from 'components/setting/workDocsSchemeClass/WorkDocsSchemeClassModal'
import WorkDocsWorkAreaModal from 'components/setting/workDocsWorkArea/WorkDocsWorkAreaModal'
import ProjectSchemesAndDocumentsPdfModal from 'components/project/schemesAndDocuments/ProjectSchemesAndDocumentsPdfModal'

export default {
  name: 'ProjectSchemesTableItem',
  components: {
    WorkDocsSchemeTypeModal,
    WorkDocsSchemeClassModal,
    WorkDocsWorkAreaModal,
    DeleteModal,
    ProjectSchemesAndDocumentsPdfModal,
  },
  props: [
    'item',
    'itemKey',
    'limit',
    'edit',
    'schemeTypeList',
    'schemeClassList',
    'workAreaList',
    'upload',
    'editShowPage',
    'tableMin',
  ],
  data: () => ({
    data: {
      name: '',
      scheme_type_id: null,
      scheme_class_id: null,
      work_area_id: null,
    },
    dialog: false,
    fileExtension: null,
    fileSize: null,
    url: null,
  }),
  watch: {
    item() {
      this.onActualData()
    },
    edit() {
      this.onActualData()
    },
    data: {
      handler: function (oldVal, newVal) {
        if (this.edit) {
          this.itemData(true)
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['inputRules']),
    ...mapGetters('workDocsProjectSchemes', ['uploadSchemesProgress']),
  },
  mounted() {
    this.onActualData()
  },
  methods: {
    onActualData() {
      this.data.name = this.item.name
      this.data.work_area_id = this.item.work_area ? this.item.work_area.id : null
      this.data.scheme_class_id = this.item.scheme_class ? this.item.scheme_class.id : null
      this.data.scheme_type_id = this.item.type ? this.item.type.id : null
      if (this.item.files && !this.upload) {
        let filesData = JSON.parse(this.item.files)
        this.fileExtension = filesData[0].extension
        this.fileSize = filesData[0].size
        this.url = filesData[0].url
      }
      this.itemData()
    },
    itemData(edit) {
      if (this.edit) {
        let data = {
          id: this.item.id,
          project_id: this.$route.params.id,
          files: this.item.files,
        }
        data = { ...this.data, ...data }
        this.$emit('itemData', { data, type: edit ? 'edit' : false, key: this.itemKey })
      }
    },
    onPdfModal() {
      this.dialog = true
    },
  },
}
</script>

<style lang="scss" scoped>
.height {
  height: 100%;
}
.width {
  min-width: 280px;
}
tr {
  min-width: 100%;
}
tr:deep() {
  &.upload {
    background-color: #f8fcff;
    &:hover {
      background-color: #f8fcff !important;
    }
  }

  td {
    .name {
      .name_top {
        display: grid;
        grid-template-columns: auto max-content;
        justify-content: start;
        align-items: center;
        align-content: center;
        p {
          margin: 0;
          line-height: 1 !important;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          color: var(--v-secondary-darken4);
        }
      }

      span {
        display: block;
        color: #b4b4b4;
        font-weight: normal;
        overflow-wrap: normal;
        @media #{map-get($display-breakpoints, 'sm-and-down')} {
          text-align: right;
        }
      }
    }
    &.noSelect {
      span {
        color: #b4b4b4 !important;
      }
    }
    .customBtn {
      margin-top: 5px;
    }
    .statusDownload {
      display: grid;
      grid-row-gap: 10px;
    }
  }
  &.noSelect {
    span {
      color: #b4b4b4 !important;
    }
  }
  .customBtn {
    margin-top: 5px;
  }
  .statusDownload {
    display: grid;
    grid-row-gap: 10px;
  }
}
</style>
